import React, { useState } from "react";
import {
  Dialog,
  Divider,
  InputAdornment,
  TextField,
  MenuItem,
  Popover,
} from "@material-ui/core";
import { ImageUtil } from "../../../utils";
import InfiniteScroll from "react-infinite-scroller";
import { P_Props } from "./BlogListing.type";
import {
  CategoryCard1,
  FloatingButton,
  Loading,
  Notification,
  Pulse,
  CustomStatus,
  CustomButton,
} from "../../components";
import { TEXT, CATEGORY_TYPES } from "../../../constants";
import { BlogStatus, BlogCategoryApiOutputModel } from "../../../models";
import moment from "moment";
import { BlogForm, CategoryForm } from "..";
import { ProductIcon, PostSubIcon } from "../../icons";
import {
  Visibility as VisibilityIcon,
  VisibilityOff as VisibilityOffIcon,
  PriorityHigh as PriorityHighIcon,
  Edit,
  Search,
  Delete
} from "@material-ui/icons";
import { EditIcon, DeleteIcon } from "../../icons";

const BlogListingPresenter: React.FC<P_Props> = (props) => {
  const [visibleFloatingBtn, setVisibleFloatingBtn] = useState<boolean>(false);
  const [categoryDetele, setCategoryDetele] = useState<BlogCategoryApiOutputModel | undefined>();
  const [visibleDeleteCategoryModal, setVisibleDeleteCategoryModal] = useState<boolean>(false);
  const [visibleDeleteBlogModal, setVisibleDeleteBlogModal] = React.useState<{
    visible: boolean;
    code: string | null;
    title: string | null
  }>({ visible: false, code: null, title: null });

  const [categoryPopup, setCategoryPopup] = React.useState<{
    anchorEl: HTMLButtonElement | null;
    category: BlogCategoryApiOutputModel | null;
  }>({ anchorEl: null, category: null });

  const openCategoryPopup = (
    event: React.MouseEvent<HTMLButtonElement>,
    category: BlogCategoryApiOutputModel
  ) => {
    setCategoryPopup({ anchorEl: event.currentTarget, category });
  };

  const closeCategoryPopup = () => {
    setCategoryPopup({ anchorEl: null, category: null });
  };

  const toggleDeleteCategoryModal = (cate) => {
    if (cate) {
      setCategoryDetele(cate);
    }
    setVisibleDeleteCategoryModal(!visibleDeleteCategoryModal);
  };

  const toggleDeleteBlogModal = (code? : string, title? : string) => {
    (code && title) ? setVisibleDeleteBlogModal({visible: true, code, title}) : setVisibleDeleteBlogModal({visible: false, code: null, title: null});
  };

  const toggleFloatingBtn = () => {
    setVisibleFloatingBtn(!visibleFloatingBtn);
  };

  const activeCategory = props.categories.find(
    (cate) => cate.link === props.filter.categoryUrl
  );
  return (
    <>
      <div className="blog-listing">
        <div className="blog-listing__category">
          <div className="blog-listing__category__header">
            <div className="title">Category</div>
          </div>
          <div
            className={`blog-listing__category__item ${
              !activeCategory ? "active" : ""
            }`}
            onClick={() => {
              props.onChangeCategory("");
            }}
          >
            <div className="blog-listing__category__item__form">
              {/* <Avatar alt="All" src="/static/images/avatar/1.jpg">
                T
              </Avatar> */}
              <div className="blog-listing__category__item__name">
                All posts
              </div>
            </div>
          </div>
          <Divider style={{ width: "100%", margin: "1.6rem 0" }} />
          <div className="blog-listing__category__list">
            {props.categories.map((cate) => {
              const isActive = cate.link === activeCategory?.link;

              return (
                <CategoryCard1
                  key={cate.id}
                  name={cate.title}
                  onClick={() => {
                    props.onChangeCategory(cate.link);
                  }}
                  selected={isActive}
                  onActionClick={(e) => {
                    openCategoryPopup(e, cate);
                  }}
                  buildPictureSrc={ImageUtil.buildBlogCategoryImgSrc}
                  isAvatar={true}
                />
              );
            })}
          </div>
        </div>
        <div 
          className="blog-listing__content"
          style={{ 
            opacity: visibleFloatingBtn ? "0.25" : "1", 
            pointerEvents: visibleFloatingBtn ? "none" : "auto"
          }}
        >
          <div className="blog-listing__content__header">
            <div className="blog-listing__content__header__title">
              {activeCategory?.title || "All posts"}
            </div>
            <div className="blog-listing__content__header__actions">
              <TextField
                placeholder="Search by name"
                variant="outlined"
                className="search-input"
                inputProps={{ className: "input" }}
                InputProps={{
                  // style: { fontSize: "1.4rem" },
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search className="icon" />
                    </InputAdornment>
                  ),
                }}
                onChange={(e) => {
                  props.onSearch(e.target.value);
                }}
              />
            </div>
          </div>
          <div className="blog-listing__content__list">
            <div className="blog-listing__content__list__header">
              <div className="text blog-listing__content__list__index">
                Order no.
              </div>
              <div className="text blog-listing__content__list__title">
                Title
              </div>
              <div className="text blog-listing__content__list__author">
                Author
              </div>
              <div className="text blog-listing__content__list__status">
                Status
              </div>
              <div className="text blog-listing__content__list__date">Date</div>
              <div className="text blog-listing__content__list__control"></div>
            </div>
            <InfiniteScroll
              useWindow={false}
              pageStart={1}
              initialLoad={false}
              hasMore={
                !props.fetchedBlog.loading &&
                props.fetchedBlog.totalPages > props.fetchedBlog.page
              }
              loadMore={() => {
                props.onLoadMore();
              }}
            >
              {!Boolean(props.fetchedBlog.data.length) &&
                props.fetchedBlog.loading && <Loading />}
              {props.fetchedBlog.data.map((blog, index) => {
                return (
                  <div
                    key={blog.id}
                    className="blog-listing__content__list__item"
                  >
                    <div className="blog-text blog-listing__content__list__index">{index + 1}</div>
                    <div
                      className="blog-text blog-listing__content__list__title"
                      onClick={() => {
                        props.openBlogFormModal(blog.code);
                      }}
                    >
                      {blog.title}
                    </div>
                    <div className="blog-text blog-listing__content__list__author">
                      {blog.author || TEXT.EMPTY}
                    </div>
                    <div className="blog-text blog-listing__content__list__status">
                      <CustomStatus
                        color={
                          blog.status === BlogStatus.PUBLISH
                            ? "#08C4E3"
                            : "#BDC6D7"
                        }
                        title={blog.status}
                        style={{ textTransform: "capitalize" }}
                      />
                    </div>
                    <div className="blog-text blog-listing__content__list__date">
                      {blog.publishDate
                        ? moment(blog.publishDate).format("DD/MM/yyyy")
                        : TEXT.EMPTY}
                    </div>
                    <div className="blog-text blog-listing__content__list__control">
                      <CustomButton
                        onClick={(e) => {
                          e.stopPropagation();
                          props.openBlogFormModal(blog.code);
                        }}
                        color={"transparent"}
                        item={
                          <span>
                            <EditIcon
                              size={[20, 20]}
                              viewBox={[20, 20]}
                              color={"#272B2F"}
                            />
                          </span>
                        }
                      />
                      <CustomButton
                        onClick={(e) => {
                          e.stopPropagation();
                          toggleDeleteBlogModal(blog.code, blog.title);
                        }}
                        color={"transparent"}
                        item={
                          <span>
                            <DeleteIcon
                              size={[20, 20]}
                              viewBox={[20, 20]}
                              color={"#272B2F"}
                            />
                          </span>
                        }
                      />
                    </div>
                  </div>
                );
              })}
              {Boolean(props.fetchedBlog.data.length) &&
                props.fetchedBlog.loading && <Loading />}
            </InfiniteScroll>
          </div>
        </div>
      </div>
      <FloatingButton
        visible={visibleFloatingBtn}
        onClickPrimary={() => toggleFloatingBtn()}
        btns={[
          {
            color: "orange",
            title: "Post",
            icon: <PostSubIcon size={[24, 24]} color="white" />,
            onClick: (e) => {
              props.openBlogFormModal();
            },
          },
          {
            color: "purple",
            title: "Category",
            icon: <ProductIcon size={[24, 24]} color="white" />,
            onClick: (e) => {
              props.openCategoryForm();
            },
          },
        ]}
      />

      <Dialog fullScreen open={props.visibleBlogForm}>
        <BlogForm
          blogCode={props.visibleBlogId}
          onCancel={() => {
            props.closeBlogFormModal();
          }}
          onComplete_Create={() => {
            props.closeBlogFormModal();
            props.reloadListingPage();
            toggleFloatingBtn();
          }}
          onComplete_Update={() => {
            props.closeBlogFormModal();
            props.reloadListingPage();
          }}
          onComplete_Delete={() => {
            props.closeBlogFormModal();
            props.reloadListingPage();
          }}
        />
      </Dialog>

      <Dialog maxWidth="lg" fullWidth open={props.visibleCategoryForm}>
        <CategoryForm
          categoryType={CATEGORY_TYPES.POST}
          categoryCode={props.visibleCategoryId}
          onCancel={() => {
            props.closeCategoryForm();
            closeCategoryPopup();
          }}
          //initial={visibleCategoryForm.initData || undefined}
          onComplete_Create={() => {
            props.closeCategoryForm();
            props.reloadListingCatePage();
            closeCategoryPopup();
            toggleFloatingBtn();
          }}
          onComplete_Update={() => {
            props.closeCategoryForm();
            props.reloadListingCatePage();
            closeCategoryPopup();
          }}
          onComplete_Delete={() => {
            props.closeCategoryForm();
            props.reloadListingCatePage();
            closeCategoryPopup();
          }}
        />
      </Dialog>

      <Notification
        visible={Boolean(props.visibleUpdatingBlog)}
        title={
          props.visibleUpdatingBlog?.status === BlogStatus.PUBLISH
            ? "Hide this post"
            : "Show this post"
        }
        subTitle={`Are you sure you want to ${
          props.visibleUpdatingBlog?.status ? "hide" : "show"
        } this post “${props.visibleUpdatingBlog?.title}”?`}
        icon={
          <Pulse
            color={
              props.visibleUpdatingBlog?.status === BlogStatus.PUBLISH
                ? "yellow"
                : "green"
            }
          >
            <div
              className={`blog-listing__status-modal__icon ${
                props.visibleUpdatingBlog?.status === BlogStatus.PUBLISH
                  ? "inactive"
                  : "active"
              }`}
            >
              {props.visibleUpdatingBlog?.status === BlogStatus.PUBLISH ? (
                <VisibilityOffIcon
                  style={{ fontSize: "5rem", color: "#fff" }}
                />
              ) : (
                <VisibilityIcon style={{ fontSize: "5rem", color: "#fff" }} />
              )}
            </div>
          </Pulse>
        }
        actions={
          <>
            <button
              className="blog-listing__status-modal__actions__cancel"
              onClick={() => {
                props.showBlogStatusModal();
              }}
            >
              Cancel
            </button>
            <button
              className="blog-listing__status-modal__actions__confirm"
              onClick={() => {
                props.onUpdateBlogStatus();
              }}
            >
              Confirm
            </button>
          </>
        }
      />

      <Popover
        open={Boolean(categoryPopup.anchorEl)}
        anchorEl={categoryPopup.anchorEl}
        onClose={closeCategoryPopup}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <MenuItem
          onClick={() => {
            props.openCategoryForm(categoryPopup.category?.code || undefined);
            closeCategoryPopup();
          }}
          style={{ fontSize: "1.4rem" }}
        >
          <Edit style={{ fontSize: "2.2rem", marginRight: "0.8rem" }} />
          Edit
        </MenuItem>
        <MenuItem
          onClick={() => {
            toggleDeleteCategoryModal(categoryPopup.category);
            closeCategoryPopup();
          }}
          style={{ color: "red", fontSize: "1.4rem" }}
        >
          <Delete style={{ fontSize: "2.2rem", marginRight: "0.8rem" }} />
          Delete
        </MenuItem>
      </Popover>

      <Notification
        visible={visibleDeleteBlogModal.visible}
        title="Delete Post"
        subTitle={`Are you sure you want to delete “${visibleDeleteBlogModal.title}“ post? This action cannot be undone`}
        icon={
          <Pulse color={"red"}>
            <div className="notification-icon-box red">
              <PriorityHighIcon style={{ fontSize: "5rem", color: "#fff" }} />
            </div>
          </Pulse>
        }
        actions={
          <>
            <button
              className="blog-form__delete-modal__actions__cancel"
              onClick={() => {
                toggleDeleteBlogModal();
              }}
            >
              Cancel
            </button>
            <button
              className="blog-form__delete-modal__actions__confirm"
              onClick={() => {
                toggleDeleteBlogModal();
                props.onDeleteBlog(visibleDeleteBlogModal.code);
              }}
            >
              Confirm
            </button>
          </>
        }
      />

      <Notification
        visible={visibleDeleteCategoryModal}
        title="Delete Category"
        subTitle={`Are you sure you want to delete category “${categoryDetele?.title}“? This action cannot be undone`}
        icon={
          <Pulse color={"red"}>
            <div className="notification-icon-box red">
              <PriorityHighIcon style={{ fontSize: "5rem", color: "#fff" }} />
            </div>
          </Pulse>
        }
        actions={
          <>
            <button
              className="blog-form__delete-modal__actions__cancel"
              onClick={() => {
                toggleDeleteCategoryModal(categoryDetele);
              }}
            >
              Cancel
            </button>
            <button
              className="blog-form__delete-modal__actions__confirm"
              onClick={() => {
                toggleDeleteCategoryModal(categoryDetele);
                if (categoryDetele?.code)
                  props.onDeleteCategory(categoryDetele?.code);
              }}
            >
              Confirm
            </button>
          </>
        }
      />
    </>
  );
};

export default BlogListingPresenter;
